/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Enum_Icsrm_Hsrm9Inputs */

const en_cv_extract_form_enum_icsrm_hsrm9 = /** @type {(inputs: Cv_Extract_Form_Enum_Icsrm_Hsrm9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RheinMain University of Applied Sciences`)
};

const de_cv_extract_form_enum_icsrm_hsrm9 = /** @type {(inputs: Cv_Extract_Form_Enum_Icsrm_Hsrm9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hochschule RheinMain`)
};

/**
* | output |
* | --- |
* | "RheinMain University of Applied Sciences" |
*
* @param {Cv_Extract_Form_Enum_Icsrm_Hsrm9Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_enum_icsrm_hsrm9 = /** @type {((inputs?: Cv_Extract_Form_Enum_Icsrm_Hsrm9Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Enum_Icsrm_Hsrm9Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_enum_icsrm_hsrm9(inputs)
	return en_cv_extract_form_enum_icsrm_hsrm9(inputs)
});
export { cv_extract_form_enum_icsrm_hsrm9 as "cv_extract_form_enum_ICSRM_HSRM" }